import { FC, useContext } from 'react'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import { Box, Typography, IconButton, Button, Modal } from '@mui/material'
import { useToast } from '../../../../contexts/toast.context'
import { PlaybookContext } from '../../../../contexts/playbooks.context'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import StopIcon from '@mui/icons-material/Stop'
import CloseIcon from '@mui/icons-material/Close'

import {
  getOnePlaybook,
  runPlaybook,
  stopPlaybook,
} from '../../../../services/playbook.service'
import { IPlaybook } from '../../../../types/playbook.type'

import styles from './styles.module.scss'

interface IProps {
  playbook: IPlaybook | undefined
  isOpen: boolean
  onClose: () => void
}

const PlaybookRunModal: FC<IProps> = ({ playbook, isOpen, onClose }) => {
  const { setPlaybook, setPlaybooks } = useContext(PlaybookContext)
  const { showToast } = useToast()

  const handleStart = async () => {
    if (!playbook) throw new Error('no playbook')

    const running = playbook.status === 'running'

    setPlaybook({ ...playbook })
    onClose()
    let newpb: IPlaybook = { ...playbook }
    try {
      const op = running ? stopPlaybook : runPlaybook

      const result = await op(playbook.id)
      showToast(result.success ? 'success' : 'error', result.message)
      newpb = { ...playbook, ...result.data }
      setPlaybook(newpb)
      setPlaybooks((arr) => arr.map((pb) => (pb.id === newpb.id ? newpb : pb)))
    } catch (err: any) {
      showToast('error', err.response?.data?.message || err.message)
    }

    // Refresh events list
    const resp = await getOnePlaybook(playbook.id.toString())
    if (resp.success) {
      setPlaybook({ ...newpb, events: resp.data!.events })
    }
  }

  return (
    <Modal className={styles.modal} open={isOpen} onClose={onClose}>
      <Box className={styles.modalContent}>
        <Box>
          <Box className={styles.header}>
            <Typography
              data-testid="title"
              id="enableTitle"
              className={styles.title}
            >
              Are you sure you want to{' '}
              {playbook?.status === 'running' ? 'stop' : 'start'}{' '}
              {`"${playbook?.name}"`} playbook?
            </Typography>
            <IconButton data-testid="closeButton" onClick={onClose}>
              <CloseOutlinedIcon />
            </IconButton>
          </Box>
          <Box className={styles.actions}>
            <Button onClick={onClose} startIcon={<CloseIcon />}>
              Cancel
            </Button>
            <Button
              id="runPlaybook"
              onClick={handleStart}
              variant="contained"
              startIcon={
                playbook?.status === 'running' ? (
                  <StopIcon />
                ) : (
                  <PlayArrowIcon />
                )
              }
            >
              {playbook?.status === 'running' ? 'Stop' : 'Start'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default PlaybookRunModal
